import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';

// Components
import ClockSevenDaysRange from './ClockSevenDaysRange';
import { Modal, Button } from 'react-bootstrap';
import ClockList from './ClockList';


const TimeModal = ({ userId, show, closeModal }) => {
    const [userName, setUserName] = useState(null);
    const [clockList, setClockList] = useState([]);
    const [currentDate, setCurrentDate] = useState(new Date());


    const updateDate = (previous = false) => {
        let updatedDate;
        if (previous)
            updatedDate = new Date(currentDate.getTime() - (7 * 24 * 60 * 60 * 1000));
        else
            updatedDate = new Date(currentDate.getTime() + (7 * 24 * 60 * 60 * 1000));

        setCurrentDate(updatedDate);
    }

    useEffect(() => {
        const fetchClocks = async () => {
            if (userId) {
                const url = process.env.REACT_APP_API_URL;
                const authToken = sessionStorage.getItem('auth-token');
                const selectedDate = `${currentDate.getMonth() + 1}-${currentDate.getDate()}-${currentDate.getFullYear()}`;

                // Get Name
                const requestName = await fetch(`${url}/users/${userId}`,
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${authToken}`
                        }
                    });

                const responseName = await requestName.json();

                // If the user is found
                if (responseName) {
                    setUserName(`${responseName.name} ${responseName.lastname}`);
                }

                // Get Clocks
                const requestClocks = await fetch(`${url}/clocks/${userId}/${selectedDate}`,
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${authToken}`
                        }
                    });


                const responseClocks = await requestClocks.json();

                // If the clocks are found
                if (responseClocks) {
                    setClockList(responseClocks);
                }
            }
        }

        fetchClocks();
    }, [userId, currentDate]);

    return (
        <Modal show={show} size="lg" onHide={closeModal}>
            <Modal.Header>
                <Modal.Title>Tiempo de {userName}  [<ClockSevenDaysRange current={currentDate} />]</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {clockList.length === 0 ? <div> No se encontro tiempo desde <ClockSevenDaysRange current={currentDate} /></div>  :
                    <ClockList list={clockList} />}
            </Modal.Body>
            <Modal.Footer className={styles.ModalFooter}>
                <div className={styles.PaginationButtons}>
                    <Button onClick={() => updateDate(true)}>Anterior</Button>
                    <Button onClick={() => updateDate()}>Siguiente</Button>
                </div>
                <Button variant="danger" onClick={closeModal}>Cerrar</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default TimeModal;